import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { map, takeWhile, tap } from 'rxjs/operators';
import { GetDefinedCardServiceCardModel, GetDefinedCardServiceResModel } from 'src/app/card-operations-core/models/get-defined-card-models';
import { TransactionRequestPayWDefinedCardInputParamsModel } from '../../models/transaction-request-models';
import { GetDefinedCardService } from '../../services/get-defined-card/get-defined-card.service';
import { TranscationRequestService } from '../../services/transaction-request/transcation-request.service';

@Component({
  selector: 'app-credit-card-selection',
  templateUrl: './credit-card-selection.component.html',
  styleUrls: ['./credit-card-selection.component.scss'],
})
export class CreditCardSelectionComponent implements OnInit {
  @Output() onSubmitCard = new EventEmitter<{merchantId:string}>();

  private subscriptions: Subscription = new Subscription();
  public cards!: GetDefinedCardServiceCardModel[];

  public isShow:boolean = true;
  
  constructor(
    private getDefinedCardService: GetDefinedCardService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private router: Router
  ) { }


  ngOnInit(): void {
    this.subscriptions.add(
      this.getDefinedCardService.getDefinedCard()
      .pipe(
        map((resp:GetDefinedCardServiceResModel) => {
          if(!resp.hasOwnProperty('response')){
            this.toastr.warning(this.translate.instant('CARDOPERATIONS_CARD_SELECTION_NO_CARD_FOUND'));
            this.isShow = false;
            return resp;
          }else{
            return resp;
          }
        }),
        takeWhile(resp => resp.hasOwnProperty('response')),
        map((resp:GetDefinedCardServiceResModel) => resp.response)
      )
      .subscribe(
        (cards:GetDefinedCardServiceCardModel[]) => {
          if(cards.length > 0){
            this.cards = cards;
            this.cards = this.cards.filter((test, index, array) =>
            index === array.findIndex(
              (findTest) => findTest.maskedPan === test.maskedPan
            ));
          }
        },
        err => {
          this.toastr.error(this.translate.instant('CARDOPERATIONS_QUERY_ALIAS_TRY_AGAIN'));
          this.router.navigate(['home']);
        }
      )
    );
  }

  onCardSubmit(card:GetDefinedCardServiceCardModel){
    this.onSubmitCard.emit({
      merchantId: card.tokenId,
    });
  }

}